import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { createFapiao, loadFapiaos } from 'researcher/fapiao/actions';
import { loadInvoices } from '../actions';
import { getInvoice, getPayment } from '../reducer';
import InvoiceFapiaoRequest from './InvoiceFapiaoRequest';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var invoice = _ref.invoice;
  var match = _ref2.match;
  return {
    invoice: getInvoice({
      invoice: invoice,
      match: match
    }),
    payment: getPayment({
      invoice: invoice,
      match: match
    }),
    redirectUrl: '/researcher/invoices',
    backLinkText: 'Return to My Invoices'
  };
};
var mapDispatchToProps = {
  loadInvoices: loadInvoices,
  createFapiao: createFapiao,
  loadFapiaos: loadFapiaos
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoiceFapiaoRequest));